import { useQuery } from '@tanstack/react-query';
import {
	type Coordinates,
	GoogleMap,
	useGoogleMapsLoader,
} from '@uturn/portal/components/map';
import {
	getDirections,
	usePriceCalculatorStore,
} from '@uturn/portal/store/price-calculator';
import { Card } from '@uturn/ui-kit';
import { RouteInformation } from './route-information';

export function RouteMap({ locations }: { locations: Coordinates[] }) {
	const { routeInformation } = usePriceCalculatorStore();
	const { isLoaded } = useGoogleMapsLoader();

	const { data: route = [] } = useQuery({
		queryKey: ['price-calculator', 'directions', locations],
		queryFn: async () => (await getDirections(locations)) ?? [],
		enabled: isLoaded && locations.length >= 2,
	});

	return (
		<Card className="sticky top-36 h-[78vh] overflow-hidden ">
			<GoogleMap
				initialLocation={{
					lat: 51.91359903088673,
					lng: 4.439946801361003,
				}}
				locations={locations}
				route={locations.length > 0 ? route : []}
				zoom={7}
			/>
			<RouteInformation data={routeInformation} />
		</Card>
	);
}
